import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button, Stack, Typography } from '@mui/material';
import { useAppDispatch, useAppSelector } from '@/hooks';
import { MediaContent, SortableList } from '@/components';
import { deleteAvatar } from '../../slice';
import { Avatar, NewAvatar } from '@/types';
import AvatarDrawer from './Drawer';

export const EMPTY_AVATAR: NewAvatar = {
  title: '',
};

const OrganizationAvatars = () => {
  const dispatch = useAppDispatch();
  const [selectedAvatar, setSelectedAvatar] = useState<Avatar | NewAvatar>();
  const { organizationId } = useParams<{ organizationId: string }>();

  const avatars = useAppSelector(
    (state) => state.organizations[organizationId ?? '']?.avatars ?? []
  );

  const handleDelete = (avatarId: Avatar['id']) => {
    dispatch(deleteAvatar({ organizationId: organizationId ?? '', avatarId }));
  };

  const onClose = () => {
    setSelectedAvatar(undefined);
  };

  return (
    <Stack spacing={3}>
      <Stack spacing={2} direction="row" alignItems="center">
        <Typography variant="h2" flex={1}>
          Avatars
        </Typography>
        <Button
          size="large"
          color="success"
          fullWidth={false}
          onClick={() => setSelectedAvatar(EMPTY_AVATAR)}
        >
          Crear Avatar
        </Button>
      </Stack>

      <SortableList<Avatar>
        items={avatars.map((avatar) => ({
          ...avatar,
          id: avatar.id,
          label: avatar.title,
        }))}
        onChange={() => alert('change')}
        onDelete={(_, deletedAvatar: any) => handleDelete(deletedAvatar.id)}
        onEdit={(avatar: any) => {
          delete avatar.label;
          setSelectedAvatar(avatar);
        }}
        renderItem={(a) => {
          return (
            <MediaContent
              title={a.title}
              size={a.media?.size as unknown as string}
              src={a.media?.src as unknown as string}
            />
          );
        }}
        deleteConfirmation
      />

      <AvatarDrawer avatar={selectedAvatar as Avatar} onClose={onClose} />
    </Stack>
  );
};

export default OrganizationAvatars;
